<template>
    <div class="view-file pdf" v-if="seen" @click="close_box" @contextmenu="notallowed">
        <div class="img">
            <iframe :src=path width="100%" height="100%"></iframe>
        </div>
    </div>
</template>
<script>
import { setTimeout } from 'timers'
import config from '@/services/config'
import cookies from '@/services/cookies'
    export default {
        data() {
            return {
                name: '',
                seen: false,
                index: '',
                id: '',
                path: '',

            }
        },
        methods: {
            logincall() {
                this.$parent.logincall()
            },
            load(id) {
                this.path = ''
                this.seen = true
                this.id = id

                let that = this

                let data = {
                    token: cookies.getCookie('token'),
                    id: this.id
                }

                this.$socket.emit('user-loadpdf', data, function (data) {
                    if(data.data === true) {
                        that.path = process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/pdf/'+that.id+'/'+cookies.getCookie('token')
                    }

                    if(data.data === false) {
                        that.seen = false
                        that.logincall()
                        that.$router.push('/login')
                    }
                })
            },
            notallowed(e) {
                e.preventDefault();
            },
            close_box(evt) {
                if(evt.target.className === 'view-file pdf' || evt.target.className.baseVal === 'close') {
                    this.seen = false

                    let data = {
                        token: cookies.getCookie('token'),
                        fileid: this.id
                    }
                    this.$socket.emit('deleteblock', data)

                    return
                }
            }
        }
    }
</script>